import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from "react-router-dom";
import { config } from "@/lib/config";
import { ArticleSchema, BreadcrumbSchema } from '@/components/StructuredData'

export default function Onbizalom() {
  return (
    <>
      <Helmet>
        <title>Önbizalom | BeArt Művészetterápia</title>
        <meta name="description" content="Önbizalom művészetterápiás csoport - 5 alkalmas önismereti csoport" />
        <link rel="canonical" href="https://beart.hu/onbizalom" />
      </Helmet>
      
      {/* Structured Data */}
      <ArticleSchema 
        headline="Önbizalom művészetterápiás csoport"
        description="5 alkalmas önismereti csoport az önbizalom fejlesztésére. Művészetterápiás technikák és coaching módszerek segítségével."
        author={{ name: "BeArt Művészetterápia" }}
        publisher={{ 
          name: "BeArt Művészetterápia", 
          logo: { url: "https://beart.hu/images/beart-transparent-logo.webp" } 
        }}
        datePublished="2024-01-01"
        image="https://beart.hu/images/onbizalom.png"
        url="https://beart.hu/onbizalom"
      />
      <BreadcrumbSchema 
        items={[
          { name: "Főoldal", url: "https://beart.hu" },
          { name: "Önbizalom", url: "https://beart.hu/onbizalom" }
        ]} 
      />
      
      <div className="beart-section">
        <h1 className="beart-title">Önbizalom művészetterápiás csoport</h1>
        <div>5 alkalmas</div>
        <div className="mt-4">
          <div className="w-full">
            <img
              className="mx-auto"
              src={`${config.basePath}/images/onbizalom.png`}
              alt="Önbizalom művészetterápiás csoport"
            />
          </div>
          <div className="mt-8 flex gap-4 italic">
            <blockquote>
              <div className="flex gap-2">
                <i className="bi bi-chat-quote-fill text-green-800"></i>
                „A legrosszabb ellenségeid sem tudnak annyi kárt okozni neked,
                mint a saját gondolataid."
                <br />
                &mdash; Buddha
              </div>
            </blockquote>
            <blockquote>
              <div className="flex gap-2">
                <i className="bi bi-chat-quote-fill text-green-800"></i>
                „Önmagad beutazása: a mindenség beutazása."
                <br /> &mdash; Weöres Sándor
              </div>
            </blockquote>
          </div>
          <div className="mb-8 mt-8">
            <div className="mt-4">
              Az önbizalom, a legegyszerűbben megfogalmazva annyit jelent, hogy
              bízunk önmagunkban, bízunk a képességeinkben.
            </div>
            <div className="mt-4">
              A szeptember végétől induló 5 alkalmas önismereti csoport célja,
              hogy felismerd mi táplálja az önbizalmadat és mi az, ami gátol.
              Melyek a személyes értékeid, amik segítenek a reális önértékelés és
              magabiztosság elérésben, ehhez a művészetterápia eszközeit
              alkalmazzuk az közös alkalmakon.
            </div>
            <div className="mt-4">
              Ezt a csoportot minden önmagában kétkedőnek ajánlom. Akik lebeszélik
              magukat a saját terveikről, akik nem merik elmondani a véleményüket,
              mert bizonytalanok abban, hogy amit mondani szeretnének elég jó-e,
              akik félnek a visszautasítástól, a kudarctól, a külvilág negatív
              visszajelzéseitől.
            </div>
          </div>
          <div className="mt-8 w-full p-4 text-left text-center">
            <Link
              to={`${config.basePath}/kapcsolat/onbizalom`}
              className="rounded-md bg-red-500 p-4 text-center font-bold text-white"
            >
              Jelentkezés
            </Link>
          </div>
          <div className="mt-8 hidden">
            <div className="font-bold">Időpontok:</div>
            <div>
              <ul className="m-2">
                <li className="mt-2">
                  <div className="flex">
                    <div>
                      <i className="bi bi-calendar-check mr-2 text-green-900"></i>
                    </div>
                    <div>
                      2024. szeptember 24. (17<sup>30</sup> - 21<sup>00</sup>)
                    </div>
                  </div>
                </li>
                <li>
                  <div className="flex">
                    <div>
                      <i className="bi bi-calendar-check mr-2 text-green-900"></i>
                    </div>
                    <div>
                      2024. október 8. (17
                      <sup>30</sup> - 21<sup>00</sup>)
                    </div>
                  </div>
                </li>
                <li>
                  <div className="flex">
                    <div>
                      <i className="bi bi-calendar-check mr-2 text-green-900"></i>
                    </div>
                    <div>
                      2024. október 22. (17<sup>30</sup> - 21<sup>00</sup>)
                    </div>
                  </div>
                </li>
                <li>
                  <div className="flex">
                    <div>
                      <i className="bi bi-calendar-check mr-2 text-green-900"></i>
                    </div>
                    <div>
                      2024. november 5. (17<sup>30</sup> - 21<sup>00</sup>)
                    </div>
                  </div>
                </li>
                <li>
                  <div className="flex">
                    <div>
                      <i className="bi bi-calendar-check mr-2 text-green-900"></i>
                    </div>
                    <div>
                      2024. november 19. (17<sup>30</sup> - 21<sup>00</sup>)
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
